module.exports = __webpack_public_path__ + "media/images/NPort_AboutUs-279a1f8fec766bef7768424f24834cec.jpg";